import React from "react";

/**
 * Inline icons for the portal's own progress elements (the week card, the
 * completion view, the folding sidebar blocks). The badge icons and the
 * check/flag marks live in shared-ui with the elements that draw them.
 */

const Svg = ({ children, viewBox = "0 0 24 24", strokeWidth = 1.6, ...rest }) => (
  <svg
    viewBox={viewBox}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {children}
  </svg>
);

export const BigCheckIcon = (props) => (
  <Svg strokeWidth={2.2} {...props}>
    <path d="M4 12.6 9.4 18 20 6.6" />
  </Svg>
);

export const StarIcon = (props) => (
  <Svg {...props}>
    <path d="M12 3.5 14.4 9l5.6.5-4.3 3.9 1.3 5.6L12 16l-5 3 1.3-5.6L4 9.5 9.6 9z" />
  </Svg>
);

export const ClockIcon = (props) => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 12V7.5" />
    <path d="M12 12l3.5 2.2" />
  </Svg>
);

export const MailIcon = (props) => (
  <Svg {...props}>
    <path d="M4 6.5h16v11H4z" />
    <path d="M4 7l8 6 8-6" />
  </Svg>
);

export const ChevronIcon = ({ open = false, ...props }) => (
  <Svg strokeWidth={2} style={{ transform: open ? "rotate(180deg)" : undefined }} {...props}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);
